export function OrganizationSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '每日大赛黑料网',
    url: 'https://rzxhblog.cn',
    description: '每日大赛黑料网提供每日大赛黑料官网入口与app下载，实时汇集网红塌房现场一手爆料，黑料每日更新，吃瓜爆料不停歇。',
    foundingDate: '2026-07',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'tips@meiridasaiheiliao.com',
      contactType: 'customer service',
    },
    sameAs: [
      'https://weibo.com/meiridasaiheiliao',
      'https://weixin.qq.com/meiridasaiheiliao',
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function WebSiteSchema() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '每日大赛黑料网',
    url: 'https://rzxhblog.cn',
    description: '每日大赛黑料网提供每日大赛黑料官网入口与app下载，实时汇集网红塌房现场一手爆料，黑料每日更新，吃瓜爆料不停歇。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://rzxhblog.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function WebPageSchema({ title, description, url }: { title: string; description: string; url: string }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    isPartOf: {
      '@type': 'WebSite',
      name: '每日大赛黑料网',
      url: 'https://rzxhblog.cn',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function BreadcrumbListSchema({ items }: { items: { name: string; url: string }[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function ArticleSchema({
  title,
  description,
  datePublished,
  author,
  imageUrl,
  url,
}: {
  title: string;
  description: string;
  datePublished: string;
  author: string;
  imageUrl: string;
  url: string;
}) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    datePublished,
    author: {
      '@type': 'Person',
      name: author,
    },
    image: imageUrl,
    url,
    publisher: {
      '@type': 'Organization',
      name: '每日大赛黑料网',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export function FAQPageSchema({ questions }: { questions: { question: string; answer: string }[] }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: questions.map((q) => ({
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}